module.exports = __webpack_public_path__ + "static/media/premenopause-menopause-perimenopause.e1cec70e.png";